
import { Component, Prop, Vue } from 'vue-property-decorator';
import { initClient } from '../../../../api';
import {
  ApprovalState,
  Group,
  GroupSurveyExtension,
  GroupSurveyExtensionApproval,
  IGroupSurveyExtensionApproval,
  VisitorManagementUiClient,
} from '../../../backend/backendapi';
import { emptyUUID } from '../../../../util';

@Component
export default class ApprovalGroupSelectCheckBoxes extends Vue {
  @Prop({ required: true })
  groupSurveyExtension!: GroupSurveyExtension;

  private readonly visitorManagementApi = initClient(VisitorManagementUiClient);

  readonly approvalGroups: Group[] = [];

  get selectedApprovalGroupIds(): string[] {
    this.filterOutInvalidApprovals();
    return this.groupSurveyExtension.approvals.map(e => e.approvalGroupId);
  }

  set selectedApprovalGroupIds(ids: string[]) {
    this.groupSurveyExtension.approvals.splice(0);
    this.groupSurveyExtension.approvals.push(
        ...ids
            .map(id => GroupSurveyExtensionApproval.fromJS({
              id: emptyUUID(),
              groupSurveyExtensionId: this.groupSurveyExtension.id,
              approvalGroupId: id,
              approvalState: ApprovalState.Unknown,
              approvedAt: undefined,
              approvedByContactId: undefined,
            } as IGroupSurveyExtensionApproval)));
  }

  async mounted(): Promise<void> {
    await this.reloadApprovingGroups();
  }

  private filterOutInvalidApprovals() {
    const approvalGroupIds = new Set(this.approvalGroups.map(e => e.id));
    const invalidApprovalsIndexes = this.groupSurveyExtension.approvals
        .map((a, i) => ({ a, i }))
        .filter(({ a, i }) => !approvalGroupIds.has(a.approvalGroupId))
        .map(({ a, i }) => i)
        .reverse();
    invalidApprovalsIndexes.forEach(i => {
      this.groupSurveyExtension.approvals.splice(i);
    });
  }

  private async reloadApprovingGroups() {
    const groups = await this.visitorManagementApi.getApprovalGroups();
    this.approvalGroups.splice(0);
    this.approvalGroups.push(...groups);
  }
}
